import React from 'react';
import ReactDOM from 'react-dom';
import qs from 'query-string';

import config from '../../client-config';

import './widgets.scss';
import { registerElementSizeChangeListener } from './utils/browser';
import { WIDGET_EVENTS, WIDGET_EVENT_PREFIX } from './utils/constants';

const queryString = qs.parse(location.search);
let widgetName = queryString.name;
const widgetId = queryString.id;
const forceWidth = !!queryString.bambuserLiveshoppingFloatingId;

let backendBaseUrl =
  queryString.backendBaseUrl ||
  config.widgetsAPIBaseUrl ||
  `https://${config.region || 'us-central1'}-${encodeURIComponent(config.projectId)}.cloudfunctions.net/widgets`;

if (widgetName === 'floating') {
  widgetName = 'FloatingActionButtonWidget';
} else if (widgetName === 'channel') {
  widgetName = 'ChannelWidget';
}

// We need to check if the widgetsAppEngineAPIBaseUrl is set, otherwise we might have E2E tests that fail
if (config.widgetsAppEngineAPIBaseUrl && widgetName === 'FloatingActionButtonWidget') {
  backendBaseUrl = config.widgetsAppEngineAPIBaseUrl;
}

// We need to check if the widgetsAppEngineAPIBaseUrl is set, otherwise we might have E2E tests that fail
if (widgetName === 'ChannelWidget') {
  backendBaseUrl = config.widgetsAppEngineAPIBaseUrl ?
    `${config.widgetsAppEngineAPIBaseUrl}/channels` :
    `${backendBaseUrl}/channel`;
}

// Can't use templete string in import, eslint blows up otherwise. But also disable that requirement...!
// eslint-disable-next-line prefer-template
import('./widgets/' + widgetName + '/index.js').then(Widget => {
  const rootElem = document.getElementById('root');
  if (window.parent !== window) {
    registerElementSizeChangeListener(rootElem, size => {
      const payload = JSON.stringify({
        eventName: `${WIDGET_EVENT_PREFIX}${WIDGET_EVENTS.SIZE}`,
        data: {
          forceWidth,
          id: widgetId,
          width: size.width,
          height: size.height,
        },
      });
      window.parent.postMessage(payload, '*');
    });
  }

  ReactDOM.render(<Widget.default {...queryString} backendBaseUrl={backendBaseUrl} />, rootElem);
  window.parent.postMessage(JSON.stringify({
    eventName: `${WIDGET_EVENT_PREFIX}${WIDGET_EVENTS.READY}`,
    data: { id: widgetId },
  }), '*');
}, error => {
  console.error(`Couldn\'t load widget '${widgetName}'`, error);
});
